import React, { useState, useEffect } from 'react';
import useAdminStore from '../stores/useAdminStore';
import DashboardLayout from '../components/DashboardLayout';
import { useToast } from '../components/ToastContainer';

const AdminWithdrawalPage = () => {
  const { withdrawals, fetchWithdrawals, processWithdrawal } = useAdminStore();
  const [rejectionReason, setRejectionReason] = useState('');
  const [selectedWithdrawal, setSelectedWithdrawal] = useState(null);
  const toast = useToast();

  useEffect(() => {
    fetchWithdrawals();
  }, []);

  const handleApprove = async (id) => {
    try {
      await processWithdrawal(id, 'approved');
      toast.success('Withdrawal approved!');
      fetchWithdrawals();
    } catch (err) {
      toast.error('Failed to approve withdrawal');
    }
  };

  const handleReject = async (id) => {
    if (!rejectionReason.trim()) return toast.error('Please provide rejection reason');
    try {
      await processWithdrawal(id, 'rejected', rejectionReason);
      toast.success('Withdrawal rejected!');
      fetchWithdrawals();
      setRejectionReason('');
      setSelectedWithdrawal(null);
    } catch (err) {
      toast.error('Failed to reject withdrawal');
    }
  };

  return (
    <DashboardLayout userRole="admin">
      <div className="max-w-6xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-8 dark:text-white">Withdrawal Management</h1>
        
        <div className="bg-white dark:bg-neutral-800 dark:text-neutral-300 rounded-lg shadow overflow-hidden">
          <table className="min-w-full">
            <thead className="bg-neutral-50 dark:bg-neutral-700">
              <tr>
                <th className="text-left py-3 px-6">Instructor</th>
                <th className="text-left py-3 px-6">Amount</th>
                <th className="text-left py-3 px-6">Date</th>
                <th className="text-left py-3 px-6">Status</th>
                <th className="text-left py-3 px-6">Actions</th>
              </tr>
            </thead>
            <tbody>
              {withdrawals.map(w => (
                <tr key={w._id} className="border-b">
                  <td className="py-3 px-6 dark:text-neutral-300">{w.instructor?.name}</td>
                  <td className="py-3 px-6 dark:text-neutral-300">₦{w.amount.toLocaleString()}</td>
                  <td className="py-3 px-6 dark:text-neutral-300">{new Date(w.createdAt).toLocaleDateString()}</td>
                  <td className="py-3 px-6">
                    <span className={`px-2 py-1 rounded-full text-xs ${
                      w.status === 'approved' ? 'bg-green-100 text-green-800' :
                      w.status === 'rejected' ? 'bg-red-100 text-red-800' :
                      'bg-yellow-100 text-yellow-800'
                    }`}>
                      {w.status}
                    </span>
                  </td>
                  <td className="py-3 px-6">
                    {w.status === 'pending' ? (
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleApprove(w._id)}
                          className="text-green-600 hover:text-green-800"
                        >
                          Approve
                        </button>
                        <button
                          onClick={() => setSelectedWithdrawal(w._id)}
                          className="text-red-600 hover:text-red-800"
                        >
                          Reject
                        </button>
                      </div>
                    ) : (
                      <span className="text-neutral-500 dark:text-neutral-300">Processed</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Rejection Modal */}
        {selectedWithdrawal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white dark:bg-neutral-800 p-6 rounded-lg w-full max-w-md">
              <h3 className="text-lg font-medium mb-4">Reject Withdrawal</h3>
              <textarea
                value={rejectionReason}
                onChange={(e) => setRejectionReason(e.target.value)}
                placeholder="Enter rejection reason..."
                className="w-full px-3 py-2 border rounded-lg mb-4"
                rows="3"
              />
              <div className="flex justify-end gap-2">
                <button
                  onClick={() => setSelectedWithdrawal(null)}
                  className="px-4 py-2 text-neutral-700 dark:text-neutral-300"
                >
                  Cancel
                </button>
                <button
                  onClick={() => handleReject(selectedWithdrawal)}
                  className="px-4 py-2 bg-red-500 text-white rounded-lg"
                >
                  Reject
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default AdminWithdrawalPage;